module.exports = __webpack_public_path__ + "img/cost-repair.46e7e314.svg";